import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=e2a876ba&scoped=true"
import script from "./Merchandise.vue?vue&type=script&lang=js"
export * from "./Merchandise.vue?vue&type=script&lang=js"
import style0 from "./Merchandise.vue?vue&type=style&index=0&id=e2a876ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a876ba",
  null
  
)

export default component.exports